import React, { useState } from "react";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { setAlertCount } from "features/alert/alertSlice";
import { useDispatch } from "react-redux";
import { alertCount as alertCountApi } from "config/apis";

function FilterCard({ onDateLoad }) {
  const [selectedDate, setSelectedDate] = useState("");
  const dispatch = useDispatch();

  const handleLoad = async () => {
    if (!selectedDate) return;
    const token = localStorage.getItem("token");

    try {
      const response = await fetch(alertCountApi, {
        method: "POST",
        headers: { "x-dhundhoo-session": token, "Content-Type": "application/json" },
        body: JSON.stringify({ startDate: selectedDate, endDate: selectedDate }),
      });

      const data = await response.json();
      dispatch(setAlertCount(data));
      onDateLoad(selectedDate); // Dashboard ko batana ki data load ho gaya
    } catch (error) {
      console.error("Error fetching alert count:", error);
    }
  };

  return (
    <MDBox display="flex" alignItems="center" gap={2} p={2}>
      <MDInput
        type="date"
        value={selectedDate}
        onChange={(e) => setSelectedDate(e.target.value)}
        sx={{ minWidth: "160px" }}
      />
      <MDButton variant="gradient" color="warning" onClick={handleLoad}>Load</MDButton>
      <MDButton variant="outlined" color="secondary" onClick={() => setSelectedDate("")}>Clear</MDButton>
    </MDBox>
  );
}

export default FilterCard;